import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../enums/QueryKey';
import {
    getWorkingHours,
    getWorkingHoursByWorkingUnit,
    getWorkingHoursByWorkingUnitLocation,
} from '../../services/workingHours';

export const useWorkingHours = ({ workingUnit }: { workingUnit?: number }) => {
    const { data, isLoading, isFetchedAfterMount, isFetching, refetch } = useQuery({
        queryKey: [QueryKey.WorkingHours, { workingUnit }],
        queryFn: () => getWorkingHours({ workingUnit }),
        enabled: !!workingUnit,
        keepPreviousData: true,
        initialData: [],
    });

    return { data, isFetching, isLoading, refetch, isFetchedAfterMount };
};

export const useWorkingHoursByWorkingUnitLocation = (workingUnitLocationId: number) => {
    const { data, isLoading, isFetching } = useQuery({
        queryKey: [QueryKey.WorkingHours, { workingUnitLocationId }],
        queryFn: () => getWorkingHoursByWorkingUnitLocation(workingUnitLocationId),
        enabled: !!workingUnitLocationId,
        refetchOnWindowFocus: false,
    });

    return { data: data || [], isLoading, isFetching };
};

export const useWorkingHoursByWorkingUnit = (workingUnitId: number) => {
    const { data, ...rest } = useQuery({
        queryKey: [QueryKey.WorkingHours, { workingUnitId }],
        queryFn: () => getWorkingHoursByWorkingUnit(workingUnitId),
        enabled: !!workingUnitId,
        refetchOnWindowFocus: false,
    });

    return {
        data: data || [],
        ...rest,
    };
};
